import { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@upmc/ims.component-library';

import axiosInstance from '../../../services/axios/axios';
import { addMessage, clearMessages } from '../../../store/ancillary/actions';
import { WrapImsPacket, getSession } from '../../../store/utility';
import WithLoadingHandler from '../../../hoc/withLoadingHandler/withLoadingHandler';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import Card, {
	Actions,
	ActionButtons,
} from '../../../components/UI/MDC/Card/Card';
import {
	Headline4,
	Headline6,
} from '../../../components/UI/MDC/Typography/Typography';
import { CSS_CLASSES } from './_constants';
import { SubmitButton } from '../../../components/UI/Input/Button/index';
import classes from './Approve.module.scss';

const Approve = props => {
	const dispatch = useDispatch();

	const [useEventID, setUseEventID] = useState(0);
	const [useActionID, setUseActionID] = useState(0);
	//const [useSubmitStatus, setUseSubmitStatus] = useState(null);
	const [useLoading, setUseLoading] = useState(true);
	const [useEsoID, setUseEsoID] = useState(null);

	const [useComment, setUseComment] = useState(null);
	const [useShowLayout, setUseShowLayout] = useState('loading');

	//  Functional equivalent of componentDidMount
	useEffect(() => {
		//  Need to get the screen info based on the passed eventID by calling the backend
		var qstringList = props.querystring.split('=');

		var tempEventList = qstringList[1].split('!!');
		var parsedEventTemp = tempEventList[0].split('&');
		var eventID = parsedEventTemp[0];
		var actions = qstringList[2];

		//  Update hooks
		setUseEventID(eventID);
		setUseActionID(actions);

		let esoID;
		getSession('LoggedOnUserESO').then(loggedonUserEso => {
			esoID = loggedonUserEso;
			setUseEsoID(esoID);

			//
			//  Perform fetch to ensure that the caller is authorized and this isn't a duplicate
			//
			let payloadGet = {
				EventID: eventID,
				UserID: esoID,
			};

			axiosInstance
				.post(
					'api/ClinicalRecordingVidyoApproval/GetRequestInfo',
					WrapImsPacket(payloadGet)
				)
				.then(response => {
					if (response.status === 200) {
						if (response.data.messages.length === 0) {
							setUseLoading(false);
							setUseShowLayout('inputApprove');

							//  Valid User.  If it is an approval we proceed.  If not then we need to display Comments box.
							//  If approve we send directly.  If deny we need to show a comment box to collect the reason
							if (actions === '1') {
								setUseShowLayout('inputApprove');
								setUseLoading(false);
							} else {
								setUseShowLayout('inputDecline');
								setUseLoading(false);
							}
						} else {
							dispatch(clearMessages());
							dispatch(
								addMessage({
									Key: response.data.messages[0].Key,
									Value: response.data.messages[0].Value,
								})
							);
							setUseLoading(false);
							setUseShowLayout('failure');
						}
					} else {
						//  failed for some reason
						dispatch(clearMessages());
						dispatch(
							addMessage({
								Key: response.data.messages[0].Key,
								Value: response.data.messages[0].Value,
							})
						);
					}
				})
				.catch(error => {
					dispatch(clearMessages());
					dispatch(
						addMessage({
							Key: error.messages[0].Key,
							Value: error.messages[0].Value,
						})
					);
					setUseShowLayout('failure');
				});
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//  Update Request
	const submit = args => {
		//  create payload for call (may need to format the date better)
		//let payload = {"EventID":useEventID, "Action":useActionID}
		let payload = {
			EventID: args.eventID,
			Action: args.actionID,
			UserID: args.eso,
			Comment: args.comment,
		};

		axiosInstance
			.post(
				'api/ClinicalRecordingVidyoExpApproval',
				WrapImsPacket(payload)
			)
			.then(response => {
				if (response.status === 200) {
					if (response.data.status === true) {
						setUseShowLayout('success');
					} else {
						dispatch(clearMessages());
						dispatch(
							addMessage({
								Key: response.data.messages[0].Key,
								Value: response.data.messages[0].Value,
							})
						);
						setUseShowLayout('failure');
					}
				} else {
					//  failed for some reason
					dispatch(clearMessages());
					dispatch(
						addMessage({
							Key: response.data.messages[0].Key,
							Value: response.data.messages[0].Value,
						})
					);
					setUseShowLayout('failure');
				}
			})
			.catch(error => {
				dispatch(clearMessages());
				dispatch(
					addMessage({
						Key: error.messages[0].Key,
						Value: error.messages[0].Value,
					})
				);
				setUseShowLayout('failure');
			})
			.finally(() => {
				setUseLoading(false);
			});
	};

	//  Render Screen Elements
	const buildScreen = () => {
		switch (useShowLayout) {
			case 'loading':
				return null;
			case 'failure':
				return null;
			case 'success':
				return null;
			case 'inputDecline':
				return (
					<Fragment>
						<StyleAuxiliary classes={classes[CSS_CLASSES.PROFILE]}>
							<Headline6
								className={classes[CSS_CLASSES.PROFILE_TITLE]}
							>
								Enter reason for denial.
							</Headline6>

							<textarea
								name='textValue'
								onChange={handleChange}
								rows={8}
								cols={150}
								maxlength={255}
								autofocus={true}
							/>
						</StyleAuxiliary>
						<Actions className={classes[CSS_CLASSES.ACTIONS]}>
							<ActionButtons>
								<SubmitButton onClick={handleSubmit}>
									Submit
								</SubmitButton>
							</ActionButtons>
						</Actions>
					</Fragment>
				);
			case 'inputApprove':
				return (
					<Fragment>
						<StyleAuxiliary classes={classes[CSS_CLASSES.PROFILE]}>
							<Headline6
								className={classes[CSS_CLASSES.PROFILE_TITLE]}
							>
								Enter reason for approval.
							</Headline6>

							<textarea
								name='textValue'
								onChange={handleChange}
								rows={8}
								cols={150}
								maxlength={255}
								autofocus={true}
							/>
						</StyleAuxiliary>
						<Actions className={classes[CSS_CLASSES.ACTIONS]}>
							<ActionButtons>
								<SubmitButton outlined onClick={handleSubmit}>
									Submit
								</SubmitButton>
							</ActionButtons>
						</Actions>
					</Fragment>
				);
			default:
				return null;
		}
	};

	//  Handle updating of Comments Textarea
	const handleChange = event => {
		setUseComment(event.target.value);
	};

	//  Wrap button click for Submit
	const handleSubmit = () => {
		//  Does the comments box have input
		if (isEmpty(useComment)) {
			dispatch(clearMessages());
			dispatch(
				addMessage({
					Key: 2,
					Value: 'Comment field cannot be empty.  Please enter a comment',
				})
			);
		} else {
			//  pass values to post function
			var payload = {
				eventID: useEventID,
				actionID: useActionID,
				eso: useEsoID,
				comment: useComment,
			};
			submit(payload);
		}
	};

	//  Is string empty
	const isEmpty = str => {
		return !str || 0 === str.length;
	};

	//  Screen Rendering
	return (
		<StyleAuxiliary classes={classes[CSS_CLASSES.CONTAINER]}>
			<Card large>
				<StyleAuxiliary classes={classes[CSS_CLASSES.TITLE_CONTAINER]}>
					<Button
						sx={{visibility: 'hidden'}}
					>
						Help
					</Button>
					<Headline4 className={classes[CSS_CLASSES.TITLE]}>
						Approve/Deny Clinical Recording Capability - Vidyo
						Access
					</Headline4>
					<Button
						sx={{visibility: 'hidden'}}
						variant='text'
						aria-label='Help'
						color='primary'
						href=''
						rel='noopener noreferrer'
						target='_blank'
						title='Help'
					>
						Help
					</Button>
				</StyleAuxiliary>
				<WithLoadingHandler isLoading={useLoading}>
					{buildScreen()}
				</WithLoadingHandler>
			</Card>
		</StyleAuxiliary>
	);
};

export default Approve;
